import type { Feature } from './types';

import chain from '../chain';
import { getEnvValue } from '../utils';
import opSuperchain from './opSuperchain';

const title = 'Blockchain interaction (writing to contract, etc.)';

const getWalletConnectProjectId = () => getEnvValue('NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID');

const config: Feature<{ walletConnect: { projectId: string } }> = {
  title,
  get isEnabled() {
    // all chain parameters are required for wagmi provider
    // @wagmi/chains/dist/index.d.ts
    const isSingleChain = Boolean(
      chain.id &&
      chain.name &&
      chain.currency.name &&
      chain.currency.symbol &&
      chain.currency.decimals &&
      chain.rpcUrls.length > 0,
    );

    const isOpSuperchain = opSuperchain.isEnabled;
    const walletConnectProjectId = getWalletConnectProjectId();

    return Boolean(
      (isSingleChain || isOpSuperchain) &&
      walletConnectProjectId,
    );
  },
  get walletConnect() {
    return {
      projectId: getWalletConnectProjectId()!,
    };
  },
};

export default config;
